import { useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Label,
  Button,
  Row,
  Col,
  Input,
} from "reactstrap";
// perguntas
import { quiz1 } from "./questions";
import { postSurvey } from "../../services/survey";
import { createEarnedPoints } from "../../services/ranking";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function Form(props) {
  const { user } = props;
  // carregamento
  const [loading, setLoading] = useState(false);
  // opção selecionada
  const [selected, setSelected] = useState(null);
  // alerta
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState(false);

  async function sendData() {
    setLoading(true);

    try {
      const dataApi = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: "O que é o Nação VC?",
        answer: selected.label,
        hit: selected.correct,
      };

      const resSurvey = await postSurvey(dataApi);

      if (resSurvey.message === "created") {
        const dataRanking = {
          code: selected.codePoint,
          positive: true,
          log: "Enquete Votorantim",
        };

        const resRanking = await createEarnedPoints(
          dataRanking,
          user.idEvent,
          user.idPart,
        );

        setAlertSuccess(true);
      }
    } catch (error) {
      setAlertError(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {alertError && (
        <SweetAlert error title="Erro" onConfirm={() => setAlertError(false)}>
          Erro ao salvar formulário
        </SweetAlert>
      )}

      {alertSuccess && (
        <SweetAlert
          success
          title="Enviado"
          onConfirm={() => window.location.reload()}
        >
          Formuário salvo com sucesso!
        </SweetAlert>
      )}

      <>
        <Card className={"card-votorantim"}>
          <CardBody>
            <CardTitle style={{ fontStyle: 'italic' }}>O que é o Nação VC?</CardTitle>
            <form
              style={{ display: "flex", flexDirection: "column" }}
              onSubmit={(e) => {
                e.preventDefault();
                sendData();
              }}
            >
              {quiz1.map((e, i) => (
                <div
                  className={`option-votorantim ${selected && selected.label === e.label ? "option-votorantim-selected" : ""}`}
                  onClick={() => setSelected(e)}
                  style={{ width: "100%" }}
                >
                  <Label style={{ marginBottom: 0 }} className={`form-label`}>
                    {e.label}
                  </Label>
                </div>
              ))}

              <Row style={{ marginTop: 30 }}>
                <Col
                  md={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    color="success"
                    type="submit"
                    disabled={loading || !selected}
                    style={{ width: 140 }}
                  >
                    {loading ? "Carregando" : "Salvar"}
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
      </>
    </>
  );
}
